import React from "react";
import "./NotificationResult.scss";
import VehicleCard from "./VehicleCard";

const NotificationResult = (props) => {
  const { expandAll, notificationData } = props;
  return (
    <div className="notification-result-container">
      {notificationData.length > 0 &&
        notificationData.map((data, index) => {
          return <VehicleCard key={data.vehicleId} data={data} expandAll={expandAll} />;
        })
      }
    </div>
  );
};

export default NotificationResult;
